import { memo, useState } from "react";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import AddIcon from "@mui/icons-material/Add";
import { PROOF_FILE } from "consts/ecommerce";
import { OnboardingInputControl } from "ui/molecules/Input";
import { ProofFileInput, acceptRules, IdentityPlaceholderTitle } from "ui/forms/formik-elements/FileInput";
import { FormField, type OnboardingMarketingWebsiteAndSupportProps } from "./types";

const RefundChargebackPolicyFileUploader = ({
    values,
    isIncomplete,
    requestedChangeFields,
    setFieldValue,
    setFieldTouched
}: OnboardingMarketingWebsiteAndSupportProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <>
            <Button
                sx={{
                    mb: 2
                }}
                variant='text'
                startIcon={<AddIcon />}
                onClick={() => setIsCollapsed(state => !state)}
            >
                Attach a document instead of typing
            </Button>
            <Collapse
                in={isCollapsed}
            >
                <OnboardingInputControl
                    name={FormField.RefundChargebackPoliciesFileKey}
                    isIncomplete={isIncomplete}
                    requestedChangeFields={requestedChangeFields}
                    renderInput={({ disabled }) => (
                        <ProofFileInput
                            multiple={false}
                            disabled={disabled}
                            name={FormField.RefundChargebackPoliciesFileKey}
                            file={values[FormField.RefundChargebackPoliciesFileKey]}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            placeholderProps={{
                                titleSlot: (
                                    <IdentityPlaceholderTitle />
                                )
                            }}
                            accept={acceptRules.identity}
                            maxSize={PROOF_FILE.maxSize}
                        />
                    )}
                />
            </Collapse>
        </>
    );
};

export default memo(RefundChargebackPolicyFileUploader);
